import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { CanvasContextMenu, CanvasContextMenuItem } from "../components/canvas/canvas-models";
import { LoggerService } from "./logger.service";

@Injectable({
  providedIn: "root",
})
export class NodeService {
  private apiUrl = "http://localhost:8000/api/nodes";

  // BehaviorSubject for random context menu items
  private contextMenuItemsSubject = new BehaviorSubject<CanvasContextMenuItem[]>(
    this.generateRandomContextMenuItems()
  );

  constructor(
    private http: HttpClient,
    private logger: LoggerService,
  ) {}

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      "Content-Type": "application/json",
      Accept: "application/json",
    });
  }

  /**
   * Get the current context menu and generate a new one for the next call
   * TODO: Replace with real API call
   */
  getNextNodesAsContextMenu(nodeId: string, nodeType: string): CanvasContextMenu {
    this.logger.info(`Fetching next nodes for nodeId=${nodeId}, nodeType=${nodeType}`);

    // Placeholder for real endpoint - uncomment when backend is ready:
    // return this.http.get<CanvasContextMenuItem[]>(
    //   `${this.apiUrl}/next-nodes?nodeId=${nodeId}&nodeType=${nodeType}`,
    //   { headers: this.getHeaders() }
    // ).pipe(
    //   map(items => ({ items }))
    // );

    // For now, return the current items and generate new ones for next call
    const currentItems = this.contextMenuItemsSubject.value;
    this.contextMenuItemsSubject.next(this.generateRandomContextMenuItems());
    return { items: currentItems };
  }

  /**
   * Generate a random list of oil and gas context menu items
   */
  private generateRandomContextMenuItems(): CanvasContextMenuItem[] {
    const allOptions: Array<{ label: string; type: string }> = [
      { label: "Wellbore", type: "Wellbore" },
      { label: "Trajectory", type: "Trajectory" },
      { label: "Formation", type: "Formation" },
      { label: "Reservoir", type: "Reservoir" },
      { label: "Production Data", type: "ProductionData" },
      { label: "Drilling Plan", type: "DrillingPlan" },
      { label: "Completion", type: "Completion" },
      { label: "Perforation", type: "Perforation" },
      { label: "Casing", type: "Casing" },
      { label: "Cement", type: "Cement" },
      { label: "Logs", type: "Logs" },
      { label: "Seismic", type: "Seismic" },
      { label: "Core Sample", type: "CoreSample" },
      { label: "Fluid Analysis", type: "FluidAnalysis" },
      { label: "Pressure Test", type: "PressureTest" },
      { label: "Flow Rate", type: "FlowRate" },
      { label: "Gas Analysis", type: "GasAnalysis" },
      { label: "Oil Quality", type: "OilQuality" },
      { label: "Water Cut", type: "WaterCut" },
      { label: "Decline Curve", type: "DeclineCurve" },
    ];

    // Randomly select 2-5 items
    const count = Math.floor(Math.random() * 4) + 2; // 2 to 5 items
    const shuffled = [...allOptions].sort(() => Math.random() - 0.5);
    const selectedOptions = shuffled.slice(0, count);

    return selectedOptions.map(option => ({
      label: option.label,
      action: () => {
        this.logger.info(`Context menu action: ${option.label}`);
        // Action will be reassigned in the component to open sidenav
      }
    }));
  }
}
